import { lazy } from 'react';

export const metaComponentsList = [
  {
    name: 'generic-list',
    component: lazy(() => import('./GenericList')),
  },
];

export const getSelectedComponent = (template) => {
  const selected = metaComponentsList.find((m) => m.name === template) || {
    name: 'default-no-componenet',
    component: lazy(() => import('./NoComponent')),
  };

  return selected;
};
